import React from 'react';
import NotFound from './NotFound.js';
import PageContent from 'interweave';
import {Image,getSettings, Head, isImage} from './../../helpers';
const Page = (props) =>{
   
    const page = props.page;
    const biz = getSettings("address",props.settings);
    
    if(typeof page !== "object"){
        return <NotFound />;
    }
    const is_image = isImage(page.image);
    const bg = is_image? Image(page.image) :null;
    return <div className="hero is-fullheight is-white">
            {is_image?<div className='hero-page' style={{backgroundImage:`url(${bg})`}}></div>:null}
            <div className="section">
                <div className="container">
                    <div className="columns">
                        <div className="column is-8 is-offset-2">
                            <h1 className="is-page-title title is-1">{Head.title(`${biz("bizname")} | ${page.name}`)}</h1>
                            <PageContent content={page.content} />
                        </div>
                    </div>
                </div>
            </div>
    </div>
}
export default Page;


// WEBPACK FOOTER //
// ./src/components/themes/Page.js